// audio proccessor
let { webAudio } = window; // global to call it on session.js

function startWebAudio() {
  webAudio = new WebAudioExtended();
  window.webAudio = webAudio;
  webAudio.start().loadCalibrateSound('/audio/calibration-audio.mp3');
}

/*
 *  Copyright (c) 2015 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */

'use strict';

// WebAudioExtended helper class which takes care of the WebAudio related parts.

class WebAudioExtended {
  constructor() {
    window.AudioContext = window.AudioContext || window.webkitAudioContext;

    this.context = null;
    // this.filter = null;
    this.mic = null;
    this.delayNode = null;
    this.calibrateSound = null;
    this.connectionSound = null;
    this.gainNode = null;

    this.soundmeterCalibration = null;
  }

  start() {
    if (this.context != null) {
      this.context.close();
      this.context = null;
    }
    this.context = new AudioContext();
    // this.filter = this.context.createBiquadFilter();
    // this.filter.type = 'highpass';
    // this.filter.frequency.setValueAtTime(150, this.context.currentTime + 1);
    return this;
  }

  applyFilter(stream) {
    if (stream && stream.getAudioTracks().length == 0) return stream;

    this.stop();
    this.start();

    this.mic = this.context.createMediaStreamSource(stream);

    // this.mic.connect(this.filter);

    this.delayNode = this.context.createDelay(10);
    this.delayNode.delayTime.value = 0.0;

    this.mic.connect(this.delayNode);
    // delay node and gain node are connected
    // this.delayNode.connect(this.peer);
    this.gainNode = this.context.createGain();
    this.delayNode.connect(this.gainNode);
    // this.mic.connect(this.gainNode);

    // peer is final destinatoin
    this.peer = this.context.createMediaStreamDestination();

    this.gainNode.connect(this.peer);

    return this.peer.stream;
  }

  stop() {
    if (this.delayNode == null || this.mic == null) return;
    // if(this.filter == null || this.delayNode == null || this.mic == null) return;
    this.mic.disconnect(0);
    this.delayNode.disconnect(0);
    // this.filter.disconnect(0);
    this.mic = null;
    this.peer = null;
    this.delayNode = null;
    // this.filter = null;
  }

  setDelay(delay) {
    this.delayNode.delayTime.value = delay;
  }

  // soundboards

  loadSound(url, callback) {
    this.request = new XMLHttpRequest();
    this.request.open('GET', url, true);
    this.request.responseType = 'arraybuffer';
    this.request.onload = callback.bind(this);
    this.request.send();
  }

  play(buffer) {
    const effect = this.context.createBufferSource();
    effect.buffer = buffer;
    if (this.peer) {
      effect.connect(this.peer);
      effect.connect(this.delayNode);
      // this.delayNode.connect(this.peer)
      effect.start(0);
    }
    this.effect = effect;
  }

  stopPlaying() {
    if (this.effect) this.effect.stop(0);
  }

  loadCalibrateSound(url) {
    this.loadSound(url, this.loadCalibrateCompleted);
  }

  loadCalibrateCompleted() {
    this.context.decodeAudioData(this.request.response, (buffer) => {
      this.calibrateSound = buffer;
    });
  }

  muteMic() {
    this.gainNode.gain.setValueAtTime(0, this.context.currentTime);
  }

  playCalibrate() {
    this.play(this.calibrateSound);
    window.setTimeout(() => {
      this.gainNode.gain.setValueAtTime(1, this.context.currentTime);
    }, 6000);
  }

  // play from Buffer

  playFromBlob(url) {
    this.loadSound(url, this.loadBlobCompleted);
  }

  loadBlobCompleted() {
    this.context.decodeAudioData(this.request.response, (buffer) => {
      this.play(buffer);
    });
  }
}

/// ///////////////////////////////////////////////////////////////////////

window.delayThing = function () {
  window.AudioContext = window.AudioContext || window.webkitAudioContext;
  /* global AudioContext */
  this.context = new AudioContext();
  this.delayNode = null;
};

delayThing.prototype.addDelay = function (stream) {
  this.delayNode = this.context.createDelay(10);
  this.delayNode.delayTime.value = 0;
  this.dtime = this.delayNode.delayTime;

  this.mic = this.context.createMediaStreamSource(stream);
  this.mic.connect(this.delayNode);

  // this.delayNode.connect(this.context.destination)

  this.peer = this.context.createMediaStreamDestination();
  this.delayNode.connect(this.peer);
  return this.peer.stream;
};

delayThing.prototype.stop = function () {
  if (this.mic == null && this.peer == null) return;
  this.mic.disconnect(0);
  this.delayNode.disconnect(0);
  this.mic = null;
  this.peer = null;
};

export { startWebAudio };
